export default "/images/vendor/flag-icons/flags/1x1/pn.svg?b6d5968b108c0e9a7b4906e6020e8c18";